import React from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import {ProjectIndicator} from '@/web-components';
import {ProjectIndicatorWrapper} from './support/DeprecatedProjectIndicator.styled';
import {getProjectGroupLink} from './support/ProjectIndicatorLogic';
import {ProjectGroupIndicator_projectGroup$data} from './__generated__/ProjectGroupIndicator_projectGroup.graphql';

type DeprecatedProjectGroupIndicatorComponentProps = {
	companyProjectGroupId: number | null;
	projectGroupName?: string | null;
	projectGroupColor: string | null;
	disableLink?: boolean;
	clearSubPath?: boolean;
	showProjectName?: boolean;
	noWidthLimit?: boolean;
	noWrapper?: boolean;
};

export const DeprecatedProjectGroupIndicatorComponent = ({
	companyProjectGroupId,
	projectGroupName,
	projectGroupColor,
	disableLink = false,
	clearSubPath = false,
	showProjectName = false,
	noWidthLimit = true,
	noWrapper = false,
}: DeprecatedProjectGroupIndicatorComponentProps): JSX.Element => {
	const link = getProjectGroupLink(companyProjectGroupId?.toString(), clearSubPath, disableLink);

	// Workaround for nested_dropdown that breaks with the 100% width added by the ProjectIndicatorWrapper
	const WrapperComponent = noWrapper ? React.Fragment : ProjectIndicatorWrapper;
	return (
		<WrapperComponent>
			<ProjectIndicator
				id={companyProjectGroupId}
				customId={undefined}
				noWidthLimit={noWidthLimit}
				name={projectGroupName}
				link={link}
				disableLink={disableLink}
				color={projectGroupColor}
				clearSubPath={clearSubPath}
				isConnectedProject={true}
			/>
			{showProjectName ? <div title={projectGroupName ?? undefined}>{projectGroupName}</div> : null}
		</WrapperComponent>
	);
};

type ProjectIndicatorProps = {
	projectGroup: ProjectGroupIndicator_projectGroup$data;
	disableLink?: boolean;
	clearSubPath?: boolean;
	showProjectName?: boolean;
	noWidthLimit?: boolean;
	noWrapper?: boolean;
};
const DeprecatedProjectGroupIndicator = ({
	projectGroup,
	disableLink = false,
	clearSubPath = false,
	showProjectName = false,
	noWidthLimit = true,
	noWrapper = false,
}: ProjectIndicatorProps): JSX.Element => {
	return (
		<DeprecatedProjectGroupIndicatorComponent
			companyProjectGroupId={projectGroup.companyProjectGroupId}
			projectGroupName={projectGroup.name}
			projectGroupColor={projectGroup.color}
			disableLink={disableLink}
			clearSubPath={clearSubPath}
			showProjectName={showProjectName}
			noWidthLimit={noWidthLimit}
			noWrapper={noWrapper}
		/>
	);
};

// Exported raw component to reuse it in DeprecatedProjectIndicatorJS that wraps it in a JS fragment (since JS and TS fragments are incompatible)
export {DeprecatedProjectGroupIndicator as DeprecatedProjectGroupIndicatorNoFragment};

export default createFragmentContainer(DeprecatedProjectGroupIndicator, {
	projectGroup: graphql`
		fragment DeprecatedProjectGroupIndicator_projectGroup on ProjectGroupType {
			name
			companyProjectGroupId
			color
		}
	`,
});
